import {inject, Injectable} from '@angular/core';
import {CanDeactivateFn, Router, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {Store} from '@ngxs/store';
import {DataState} from '../store/data.state';
import {Emittable, Emitter} from '@ngxs-labs/emitter';
import {UrlListEnum} from "./url-list.enum";

@Injectable({
  providedIn: 'root'
})
export class DisableBackGuardService {
  @Emitter(DataState.backToPreviousPage) private readonly backToPreviousPage!: Emittable;
  @Emitter(DataState.backToEshop) private readonly backToEshop!: Emittable;

  constructor(private readonly store: Store) {
  }

  canDeactivate(url: string):
    Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let result = false;
    if (url === this.getScreenPathUrl()) {
      this.synchroBEvsFE(url);
    } else {
      this.setCurrentlyShowingPage(url);
      result = true;
    }
    return result;
  }

  private getScreenPathUrl(): string {
    return this.store.selectSnapshot((state: any) => state.whitebricks.flow.screenPath);
  }

  private synchroBEvsFE(url: string): void {
    if (url === '/' + UrlListEnum.PAGE_PAYMENT_PROVIDER_SELECTION) {
      this.backToEshop.emit();
    } else {
      this.backToPreviousPage.emit();
    }
  }

  private setCurrentlyShowingPage(url: string): void {
    if (!this.getScreenPathUrl()) {
      location.replace(url);
    }
  }
}


export function deactivateGuard(): CanDeactivateFn<any> {
  return () => {
    const router: Router = inject(Router);
    const disableBackGuardService: DisableBackGuardService = inject(DisableBackGuardService);
    return disableBackGuardService.canDeactivate(router.routerState.snapshot.url);
  };
}
